import { Component, Input, OnInit } from "@angular/core";
import { PaymentService } from "src/app/services/payment/payment.service";

@Component({
  selector: "payments",
  templateUrl: "./payments.component.html",
  styleUrls: ["./payments.component.scss"]
})
export class PaymentsComponent implements OnInit {
  @Input()
  mode: string; // edit, view, order, catalog, sale

  @Input()
  items: [];

  @Input()
  role: string;

  constructor(public paymentService:PaymentService) {}

  ngOnInit() {}
}
